var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("news-loader")
    : _vm.error
    ? _c("news-error")
    : _c("div", [_c("news-results", { attrs: { results: _vm.results } })], 1)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }